import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Select from '../form/Select';
import Stack from '@mui/material/Stack';

const VariablesToolbar = ({
  variables,
  loading,
  onSelect,
  fullWidth,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        '.react-select': {
          'width': fullWidth ? '100%' : 140,
          ' > div': {
            'cursor': 'pointer',
            'borderColor': alpha(theme.palette.grayed.main, 0.5),
            '&:hover': {
              borderColor: 'grayed.main',
            },
          },
        },
      }}
    >
      <Select
        transformValue
        fullWidth={fullWidth}
        placeholder="Variables"
        loading={loading}
        size="compact"
        margin="none"
        onChange={onSelect}
        options={variables}
        {...rest}
      />
    </Stack>
  );
};

export default VariablesToolbar;
